import type { AgentBillingRouter } from "replo-publisher/src/trpc/routers/agent-billing";

import { getNamespacedQueryClient } from "@v2/trpc/trpc";

import { createTrpcRouterConfig } from "../config";

const {
  router: agentBillingRouter,
  client: agentBillingClient,
  utils: agentBillingUtils,
  options: agentBillingOptions,
} = createTrpcRouterConfig<AgentBillingRouter>({
  path: "agentBilling",
  queryClient: getNamespacedQueryClient("agentBilling"),
});

export {
  agentBillingClient,
  agentBillingRouter,
  agentBillingUtils,
  agentBillingOptions,
};
